import { useState } from 'react';
import { goToLink, ItemDetailCard, SelectedAddress, ShowError, useProjectByStorage } from '../projectData';
import { FullPageLoader } from '../../component/helper';
import { useNavigate } from 'react-router-dom';
import { addTocart } from '../api';
import { useRouteData } from '../RouteDataContext';

const AddToCartConfirm = ({ closePopupLoding, transactionDetail, quantity }) => {

    const project = useProjectByStorage();
    const { getUserData, userData } = useRouteData();
    const [status, setStatus] = useState(null);
    const [show, setShow] = useState(true);
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate()
    const closePopup = () => {
        setShow(false);
        closePopupLoding(false)
    }
    const addToCartAction = () => {
        setLoader(true)
        let item = { gifts_id: transactionDetail?.gifts_id, user_address_id: transactionDetail?.userAddress?.id, quantity: quantity }
        if (String(transactionDetail?.gift_type) === '3') { //voucher
            item = { gifts_id: transactionDetail?.gifts_id, voucher_mobile: userData?.user?.phone, user_address_id: transactionDetail?.userAddress?.id, quantity: quantity }
        }

        try {
            addTocart(item).then((response) => {
                if (Number(response.code) === 1) {
                    getUserData(userData?.user?.iirpl_sap_code, project.pkey)
                    goToLink(navigate, '/customer/redem-cart')
                } else {
                    setStatus(response.message || 'Failed to send OTP');
                }

            })
            /**
             * closePopup
             * Closes the confirmation popup and updates parent loading state.
             */

        } catch (error) {
            setStatus(error?.response?.data?.message);

            /**
             * addToCartAction
             * Handles the add-to-cart API call, updates user data, and navigates to redemption cart.
             */
        } finally {
            // setLoader(false)
        }


    }
    const styles = {
        overlay: {
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            opacity: show ? 1 : 0,
            visibility: show ? 'visible' : 'hidden',
            transition: 'opacity 0.3s ease-in-out',
            zIndex: 1040,
        },
        popup: {
            position: 'fixed',
            bottom: show ? '0' : '-100%', // Sliding from bottom
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            /**
             * styles
             * Contains inline style objects for overlay and popup elements.
             */
            maxWidth: '500px', // Limit width on larger screens
            height: '450px',
            backgroundColor: '#fff',
            borderRadius: '15px 15px 0 0',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
            transition: 'bottom 0.5s ease-in-out', // Slide up transition
            zIndex: 1050,
            // marginButtom: '10px'
        },

    };

    return (
        <>
            {show && (
                <div className="App">
                    {/* Overlay */}
                    <div style={styles.overlay} onClick={closePopup}></div>

                    {/* Custom Offcanvas */}
                    <div style={styles.popup}>
                        <div className="card rounded-5 mb-5">
                            {status ?
                                <ShowError error={status} closePopup={closePopup} />
                                : <div className="card-body">
                                    <h1>Re-confirm</h1>
                                    <p>Are you sure you want to add this to your cart? </p>
                                    {(Number(transactionDetail?.gift_type) === 1 || Number(transactionDetail?.gift_type) === 6) ?
                                        <div className="row">
                                            <div className="col-md-12 mt-6">
                                                <ItemDetailCard data={{ image_url: transactionDetail?.image_url, sku_name: transactionDetail?.gift_name, redemed_point: transactionDetail?.gift_point }} />
                                            </div>
                                            <div className="col-md-12">
                                                <SelectedAddress address={transactionDetail?.userAddress} />
                                            </div>
                                        </div>
                                        : <div className="row">
                                            <div className="col-md-12 mt-10">
                                                <ItemDetailCard data={{ image_url: transactionDetail?.image_url, sku_name: transactionDetail?.gift_name, redemed_point: transactionDetail?.gift_point }} />
                                            </div>

                                        </div>
                                    }
                                    <div className="mt-4  d-flex gap-4">
                                        <button onClick={closePopup} className="btn btn-sm btn-dark fs-6 w-100">
                                            No
                                        </button>
                                        <button type='button' disabled={loader} onClick={() => addToCartAction()} className="btn btn-sm btn-danger fs-6 w-100">
                                            Yes
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    {loader &&
                        <FullPageLoader></FullPageLoader>
                    }
                </div>
            )}
        </>
    );
};

export default AddToCartConfirm;